import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconPhotographer = ({ id, color, width = 48, style, ...restProps }: IProps) => {
  const viewBoxWidth = 24;
  const viewBoxHeight = 24;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 20.5L19.5 20.5C20.6046 20.5 21.5 19.6046 21.5 18.5V7.5C21.5 6.39543 20.6046 5.5 19.5 5.5L4.5 5.5C3.39543 5.5 2.5 6.39543 2.5 7.5V18.5C2.5 19.6046 3.39543 20.5 4.5 20.5Z"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.5 10.5H6" stroke={iconColor} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 10.5H21.5" stroke={iconColor} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18Z"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.08301 13C9.08407 12.2267 9.39173 11.4854 9.93855 10.9385C10.4854 10.3917 11.2267 10.0841 12 10.083"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 4C16 3.86739 16.0527 3.74021 16.1464 3.64645C16.2402 3.55268 16.3674 3.5 16.5 3.5H18.5C18.6326 3.5 18.7598 3.55268 18.8536 3.64645C18.9473 3.74021 19 3.86739 19 4"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconPhotographer;
